import projection from '../generated/pwc205f1.json';
import { AcceptanceManifest } from '../types';

export const pwc205f1AcceptanceManifest = projection as AcceptanceManifest;
